'use client'

import Button, { buttonClassNames } from '@components/primitives/Button'
import { IconSuffix } from '@components/primitives/Icon/IconSuffix'
import { EllipsesPulse } from '@components/primitives/LoadingWrapper/EllipsesPulse'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'

export default function FormSubmitButton({
  buttonLabel = 'Next',
  className,
  formId,
  loading,
  onClick,
}: {
  buttonLabel?: string
  className?: string
  formId?: string
  loading?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}) {
  return (
    <Button
      className={classMerge(
        buttonClassNames.legacy.fill.black,
        'pointer-events-auto w-full rounded-full md:w-1/4 md:px-4',
        className,
      )}
      disabled={loading}
      form={formId}
      onClick={onClick}
      type='submit'
    >
      {loading ? (
        <EllipsesPulse className='justify-center' ellipsesColor={'bg-white'} />
      ) : (
        <IconSuffix icon={faArrowRight}>
          <span className='mr-2'>{buttonLabel ?? 'Next'}</span>
        </IconSuffix>
      )}
    </Button>
  )
}
